<main>
    <app-alert-message></app-alert-message>

    <app-modal-update></app-modal-update>

    <app-header></app-header>
    <app-current-environment></app-current-environment>
    <div class="app-router"><router-outlet></router-outlet></div>
    <app-footer></app-footer>
</main>